/**
 * Captures axios's real network adapter at import time.
 *
 * `legacyBridge.js` replaces `axios.defaults.adapter` with one that intercepts
 * calls to the retired backends and re-expresses them as REST calls. Two things
 * must never happen:
 *
 *  1. the bridge's own REST calls going back through the bridge (infinite
 *     recursion), and
 *  2. the capture depending on module import order.
 *
 * Reading the default here, in a module both sides import, fixes both: whoever
 * imports first triggers this module, and the value recorded is always the
 * genuine adapter rather than whatever has been installed since.
 */

import axios from 'axios';

// Optional chaining for one reason: a unit spec that replaces axios with a
// factory mock (`jest.mock('axios', () => ({ post: jest.fn() }))`) has no
// `defaults`, and this module is imported by the API client, which almost
// every component reaches — so the whole spec file failed to load. A real
// axios always has `defaults.adapter`.
export const nativeAdapter = axios.defaults?.adapter;

export default nativeAdapter;
